import * as React from 'react';

interface TypingIndicatorProps extends React.HTMLProps<HTMLDivElement> {
	innerRef?: React.RefObject<HTMLDivElement>;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({
	innerRef,
}) => {
	return (
		<div
			ref={innerRef}
			data-testid="typing-indicator"
			className="chat-typing-indicator border-gray-40 inline-flex self-start px-3 py-3 mx-2 mb-2 bg-white border border-solid rounded-md rounded-tl-none"
		>
			<span
				className="chat-typing-dot chat-typing-dot-first bg-ongreen block mr-2 rounded-full"
				style={{ width: '8px', height: '8px' }}
			/>
			<span
				className="chat-typing-dot chat-typing-dot-second bg-ongreen block mr-2 rounded-full"
				style={{ width: '8px', height: '8px' }}
			/>
			<span
				className="chat-typing-dot chat-typing-dot-third bg-ongreen block rounded-full"
				style={{ width: '8px', height: '8px' }}
			/>
		</div>
	);
};

export default TypingIndicator;
